import Login from '@/components/Login/Login.vue';
import UnauthAppLayout from '@/components/UnauthAppLayout/UnauthAppLayout.vue';
export default {
  components: { Login, UnauthAppLayout },
};
